import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getAwardsByApplicationId(applicationId: string) {
  return await prisma.applicantAward.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
